// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M4 10L8 6L12 10'];
